
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 315.3 473.4"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M157.8 0C70.9 0 0 67.3 0 150.1c0 63.4 31.8 99.7 57.3 128.9 15.8 18 28.2 32.3 28.2 47.4v83.3c.1 6.2 2.6 12 6.9 16.4 4.3 4.3 10.2 6.7 16.4 6.7h8.8v8.9c.1 8.5 3.5 16.6 9.5 22.5 6 5.9 14.1 9.3 22.5 9.2h16.2c8.4.1 16.5-3.3 22.5-9.2 6-5.9 9.4-14.1 9.5-22.5v-8.9h8.8c3 0 6-.5 8.8-1.7 2.8-1.1 5.4-2.8 7.5-5 2.2-2.1 3.9-4.7 5.1-7.5 1.2-2.8 1.8-5.8 1.8-8.9v-79c0-15.2 12.4-30.1 28.3-49 25.4-30.4 57-68.2 57-131.3C315.1 67.7 244.3.3 157.3.3l.5-.3zm-56.5 352.1h112.6v23.5H101.6v-23.5h-.3zm80.3 89.8c0 2.1-.4 4.2-1.3 6.1-.8 1.9-2 3.7-3.5 5.2-3 3-7 4.6-11.2 4.6h-16.2c-4.2 0-8.2-1.6-11.2-4.6-3-3-4.7-7-4.7-11.2v-9h48.1v8.9zm32-32c0 1.9-.8 3.8-2.1 5.2-1.3 1.4-3.2 2.1-5.1 2.1h-97.8c-1.9 0-3.8-.8-5.1-2.1-1.4-1.4-2.1-3.2-2.1-5.2v-18.5h112.3v18.5zm32.3-138.2c-17.2 20.5-32 38.2-32 59.2v5.3H101.3v-9.5c0-21.1-14.9-38.2-32.2-57.9-23.7-27.2-53.3-61-53.3-118.5 0-74 63.5-134.2 141.7-134.2 78.2 0 141.8 60.2 141.8 134.2 0 57.7-29.6 93-53.4 121.4","fill":"#FFF"}}),_c('path',{attrs:{"d":"M184 133.6l18.7-54.4L145 92.3l-17.9 57.9-15.3 49.7 16.5-3.5 9.6-2-21.9 78.4 53.8-69.5 20.8-26.9 19.5-25.2 5.9-7.7-38.4 8.8 6.4-18.7z","fill":"#FFF"}})])
          )
        }
      }
    